<template>      
<div key=5>    
          <div class="card-body">

            <div class="row">
              <div class="col-12">
                <div class="h5 text-muted">Contact (Customer)</div>
              </div>
            </div>

            <div class="row">

              <div class="col-12 mb-2">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <input type="radio" aria-label="Radio button for following text input" value="0" v-model="org_entry_sel">
                    </div>
                  </div>
                  <span class="form-control">Create and select new Contact</span>
                </div>
              </div>

              <div v-if="contactList.length > 0" class="col-12">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <input type="radio" aria-label="Radio button for following text input" value="1" v-model="org_entry_sel">
                    </div>
                  </div>
                  <span class="form-control">Select from existing Contacts</span>
                </div>
              </div>

            </div>
          </div>

          <transition name="slide-fade" mode="out-in">
            <div key=1 v-if="org_entry_sel == 0" class="card-body">

                <div class="row">
                  <div class="col-12 col-lg-6">
                    <div class="form-group">
                      <label for="exampleInputEmail1" class="small mb-0">First Name<i class="fa fa-asterisk text-danger ml-2" aria-hidden="true"></i></label>
                      <input type="text" class="form-control" placeholder="First Name" aria-describedby="emailHelp" v-model="f_name">
                    </div>
                  </div>

                  <div class="col-12 col-lg-6">
                    <div class="form-group">
                      <label for="exampleInputEmail1" class="small mb-0">Last Name<i class="fa fa-asterisk text-danger ml-2" aria-hidden="true"></i></label>
                      <input type="text" class="form-control" placeholder="Last Name" aria-describedby="emailHelp" v-model="l_name">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label for="exampleInputEmail1" class="small mb-0">Primary Email<i class="fa fa-asterisk text-danger ml-2" aria-hidden="true"></i></label>
                      <input type="email" class="form-control" placeholder="Email Address" aria-describedby="emailHelp" v-model="pri_email">
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label for="exampleInputEmail1" class="small mb-0">Primary Phone</label>
                      <VuePhoneNumberInput v-model="pri_phone"
                        default-country-code="US"
                        no-country-selector
                        no-validator-state
                      />
                    </div>
                  </div>
                </div> 


                <div class="row">
                  <div class="col-12 text-right">
                    <small><em><i class="fa fa-asterisk text-danger" aria-hidden="true"></i> = Required</span></em></small>
                  </div>
                </div> 
                
                <div class="row">
                  <div class="col-12">
                    <button v-if="showSaveButton == 1" class="btn btn-primary" @click="saveandSelect">Save and Use this Contact</button>
                    <button v-if="prop1 == 1" class="btn btn-danger" @click="cancel">Cancel</button>
                  </div>
                </div>
            </div>
            <div key=2 v-if="org_entry_sel == 1" class="card-body">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label for="exampleInputEmail1" class="small mb-0">Select a Contact<i class="fa fa-asterisk text-danger ml-2" aria-hidden="true"></i></label>
                    <v-select 
                      v-model="con_sel"
                      placeholder="Select a Contact"
                      label="item_data"
                      :options= "contactList"
                      :reduce="contactList => contactList.id"
                      class="p-0 bg-white style-chooser">
                    </v-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <button v-if="con_sel != ''" class="btn btn-primary" @click="selectOnly">Use this Contact</button>
                  <button v-if="prop1 == 1" class="btn btn-danger" @click="cancel">Cancel</button>
                </div>
              </div>
            </div>
          </transition>
</div>
</template>


<script>
import {store} from '../../../stores/quote-builder-main-store.js'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';


/*
prop1 = switch to tell if entering a contact, or changing contact
    0 = entering contact for first time
    1 = changing a contact from entered
*/

export default {
  store,
  props: ['prop1', 'prop2', 'prop3'],
  data: function () {
    return { 
      org_entry_sel: '0',
      con_sel: '',

      f_name: '',
      l_name: '',
      pri_email: '',
      pri_phone: '',
    }
  },
  computed: {
    contactList () { return this.$store.state.contactList },
    showSaveButton() {
      var _this = this;
      if(_this.f_name != '' && _this.l_name != '' && _this.pri_email != '' ) {
        return 1;
      } else {
        return 0;
      }
    }
  },
  watch: {
    
  },
  mounted() {
    this.contactList.map(function (x){
      return x.item_data = x.f_name + ' ' + x.l_name;
    });
  },
  methods: {
    selectOnly() {
      var _this = this;
      if(_this.con_sel == '' | _this.con_sel == null) {
        return false;
      } else {
        _this.$emit('onRecipSComplete', [ 'builder-contact', _this.con_sel, _this.prop1 ])
      }
      
    },
    cancel() {
      var _this = this;
      _this.$emit('onRecipUComplete', [ 'builder-contact', '', _this.prop1 ])
    },
    saveandSelect() {
      var _this = this;
      _this.$toastr.warning('Validating contact information.', 'Please wait!')
      //validate with js
      var valErrors = [];
      //validate first name
      if(_this.f_name == '' || _this.f_name == null) { valErrors.push("A first name is required!") }
      //validate last name
      if(_this.l_name == '' || _this.l_name == null) { valErrors.push("A last name is required!") }
      if(_this.l_name.length <= 2 ) { valErrors.push("A last name requires more than two letters!") }
      //validate email
      var mailformat = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
      if(_this.pri_email == '' || _this.pri_email == null) { 
        valErrors.push("The primary email address is required!") 
      } else if (!_this.pri_email.match(mailformat)) {
        valErrors.push("The primary email address you entered is not valid!") 
      }
      var phoneFormat = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
      if(_this.pri_phone != '' && _this.pri_phone != null) {
        if(!_this.pri_phone.match(phoneFormat)) { valErrors.push("The primary phone number you entered is invalid!") }  
      }

      if(valErrors.length > 0) {
        _this.$toastr.remove();
        _this.errorDisplay(valErrors);
        return false;
      } 

      _this.$toastr.remove()

      _this.$toastr.warning('Saving new contact information.', 'Please wait!')
      axios.post('/utility/all/contact/storecontact', {
        f_name: _this.f_name,
        l_name: _this.l_name,
        pri_email: _this.pri_email,
        pri_phone: _this.pri_phone,

      })
        .then(function (response) {
          var msg = response.data.msg;
          var a = response.data.con;
          _this.$toastr.remove()
          _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
          _this.$emit('onRecipSComplete', [ 'builder-contact', a, _this.prop1 ])
        })
        .catch(function (error) {
          var errors = error.response.data.errors;
          _this.errorDisplay(errors);
        })

    },
    
    errorDisplay(valErrors) {
      var _this = this;
      var errors = valErrors;
      var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
      $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
      errorsHTML += '</ul></div>';
      _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
    },
  },    
  components:{
    VuePhoneNumberInput,
  },
  filters: {

  }
}
</script>
